import { logger } from "@/lib/logging";
import { init as initDatadog } from "./datadog";
import { init as initSentry } from "./sentry";

/** Starts optional browser integrations without blocking app startup. */
export function bootIntegrations(): void {
  try {
    initDatadog();
  } catch (e) {
    console.warn("[datadog] init failed", e);
  }
  try {
    initSentry();
  } catch (e) {
    logger.warn({ err: e }, "[sentry] init failed");
  }
}
